import {create} from 'zustand'

export const useStore = create((set) => ({
    // valores iniciales  
    isLogued : false,

    // funciones de asignacion
    setIsLogued: (valor) => set({isLogued : valor})
}))